import { isString } from '@app/typeGuards'
import { isNull } from '@app/utils'

import type { FiltersParams } from '@app/types/filter'

export const getFilterValue = <ValueType = unknown>(
  filters: FiltersParams,
  key: keyof FiltersParams,
  adapter: (value: string) => ValueType,
  defaultValue?: string
): ValueType | null => {
  const rawFilterValue = filters[key] ?? defaultValue
  const filterValue = isString(rawFilterValue) ? rawFilterValue : null

  return isNull(filterValue) ? null : adapter(filterValue)
}
